import * as s from "react";
import U, { useState as Z, createContext as Nn, useContext as $n, useMemo as ae, useRef as ee, useCallback as An, useEffect as et, forwardRef as ar } from "react";
import * as ir from "react-dom";
import In from "react-dom";
import { Typography as mt, ShapeIcon as jn, Icons as Mn, PillButton as Ln, Button as Fn, LinkButton as Wn } from "@flash-tecnologia/hros-web-ui-v2";
import { styled as L, useTheme as Bn, css as Un } from "styled-components";
var ft = { exports: {} }, me = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mt;
function Vn() {
  if (Mt) return me;
  Mt = 1;
  var e = U, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function u(c, f, d) {
    var p, h = {}, y = null, E = null;
    d !== void 0 && (y = "" + d), f.key !== void 0 && (y = "" + f.key), f.ref !== void 0 && (E = f.ref);
    for (p in f) n.call(f, p) && !i.hasOwnProperty(p) && (h[p] = f[p]);
    if (c && c.defaultProps) for (p in f = c.defaultProps, f) h[p] === void 0 && (h[p] = f[p]);
    return { $$typeof: t, type: c, key: y, ref: E, props: h, _owner: a.current };
  }
  return me.Fragment = r, me.jsx = u, me.jsxs = u, me;
}
var ge = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lt;
function Hn() {
  return Lt || (Lt = 1, process.env.NODE_ENV !== "production" && function() {
    var e = U, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), c = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), E = Symbol.for("react.offscreen"), T = Symbol.iterator, l = "@@iterator";
    function g(o) {
      if (o === null || typeof o != "object")
        return null;
      var v = T && o[T] || o[l];
      return typeof v == "function" ? v : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function w(o) {
      {
        for (var v = arguments.length, b = new Array(v > 1 ? v - 1 : 0), S = 1; S < v; S++)
          b[S - 1] = arguments[S];
        x("error", o, b);
      }
    }
    function x(o, v, b) {
      {
        var S = C.ReactDebugCurrentFrame, N = S.getStackAddendum();
        N !== "" && (v += "%s", b = b.concat([N]));
        var $ = b.map(function(k) {
          return String(k);
        });
        $.unshift("Warning: " + v), Function.prototype.apply.call(console[o], console, $);
      }
    }
    var O = !1, R = !1, j = !1, D = !1, F = !1, V;
    V = Symbol.for("react.module.reference");
    function Q(o) {
      return !!(typeof o == "string" || typeof o == "function" || o === n || o === i || F || o === a || o === d || o === p || D || o === E || O || R || j || typeof o == "object" && o !== null && (o.$$typeof === y || o.$$typeof === h || o.$$typeof === u || o.$$typeof === c || o.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      o.$$typeof === V || o.getModuleId !== void 0));
    }
    function Ye(o, v, b) {
      var S = o.displayName;
      if (S)
        return S;
      var N = v.displayName || v.name || "";
      return N !== "" ? b + "(" + N + ")" : b;
    }
    function Re(o) {
      return o.displayName || "Context";
    }
    function X(o) {
      if (o == null)
        return null;
      if (typeof o.tag == "number" && w("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof o == "function")
        return o.displayName || o.name || null;
      if (typeof o == "string")
        return o;
      switch (o) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case d:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case c:
            var v = o;
            return Re(v) + ".Consumer";
          case u:
            var b = o;
            return Re(b._context) + ".Provider";
          case f:
            return Ye(o, o.render, "ForwardRef");
          case h:
            var S = o.displayName || null;
            return S !== null ? S : X(o.type) || "Memo";
          case y: {
            var N = o, $ = N._payload, k = N._init;
            try {
              return X(k($));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, P = 0, A, K, Y, re, xe, ve, he;
    function Te() {
    }
    Te.__reactDisabledLog = !0;
    function sn() {
      {
        if (P === 0) {
          A = console.log, K = console.info, Y = console.warn, re = console.error, xe = console.group, ve = console.groupCollapsed, he = console.groupEnd;
          var o = {
            configurable: !0,
            enumerable: !0,
            value: Te,
            writable: !0
          };
          Object.defineProperties(console, {
            info: o,
            log: o,
            warn: o,
            error: o,
            group: o,
            groupCollapsed: o,
            groupEnd: o
          });
        }
        P++;
      }
    }
    function cn() {
      {
        if (P--, P === 0) {
          var o = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, o, {
              value: A
            }),
            info: H({}, o, {
              value: K
            }),
            warn: H({}, o, {
              value: Y
            }),
            error: H({}, o, {
              value: re
            }),
            group: H({}, o, {
              value: xe
            }),
            groupCollapsed: H({}, o, {
              value: ve
            }),
            groupEnd: H({}, o, {
              value: he
            })
          });
        }
        P < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ge = C.ReactCurrentDispatcher, Xe;
    function Pe(o, v, b) {
      {
        if (Xe === void 0)
          try {
            throw Error();
          } catch (N) {
            var S = N.stack.trim().match(/\n( *(at )?)/);
            Xe = S && S[1] || "";
          }
        return `
` + Xe + o;
      }
    }
    var ze = !1, Oe;
    {
      var un = typeof WeakMap == "function" ? WeakMap : Map;
      Oe = new un();
    }
    function St(o, v) {
      if (!o || ze)
        return "";
      {
        var b = Oe.get(o);
        if (b !== void 0)
          return b;
      }
      var S;
      ze = !0;
      var N = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var $;
      $ = Ge.current, Ge.current = null, sn();
      try {
        if (v) {
          var k = function() {
            throw Error();
          };
          if (Object.defineProperty(k.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(k, []);
            } catch (q) {
              S = q;
            }
            Reflect.construct(o, [], k);
          } else {
            try {
              k.call();
            } catch (q) {
              S = q;
            }
            o.call(k.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (q) {
            S = q;
          }
          o();
        }
      } catch (q) {
        if (q && S && typeof q.stack == "string") {
          for (var _ = q.stack.split(`
`), B = S.stack.split(`
`), I = _.length - 1, M = B.length - 1; I >= 1 && M >= 0 && _[I] !== B[M]; )
            M--;
          for (; I >= 1 && M >= 0; I--, M--)
            if (_[I] !== B[M]) {
              if (I !== 1 || M !== 1)
                do
                  if (I--, M--, M < 0 || _[I] !== B[M]) {
                    var G = `
` + _[I].replace(" at new ", " at ");
                    return o.displayName && G.includes("<anonymous>") && (G = G.replace("<anonymous>", o.displayName)), typeof o == "function" && Oe.set(o, G), G;
                  }
                while (I >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Ge.current = $, cn(), Error.prepareStackTrace = N;
      }
      var oe = o ? o.displayName || o.name : "", jt = oe ? Pe(oe) : "";
      return typeof o == "function" && Oe.set(o, jt), jt;
    }
    function ln(o, v, b) {
      return St(o, !1);
    }
    function fn(o) {
      var v = o.prototype;
      return !!(v && v.isReactComponent);
    }
    function _e(o, v, b) {
      if (o == null)
        return "";
      if (typeof o == "function")
        return St(o, fn(o));
      if (typeof o == "string")
        return Pe(o);
      switch (o) {
        case d:
          return Pe("Suspense");
        case p:
          return Pe("SuspenseList");
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case f:
            return ln(o.render);
          case h:
            return _e(o.type, v, b);
          case y: {
            var S = o, N = S._payload, $ = S._init;
            try {
              return _e($(N), v, b);
            } catch {
            }
          }
        }
      return "";
    }
    var De = Object.prototype.hasOwnProperty, Rt = {}, xt = C.ReactDebugCurrentFrame;
    function ke(o) {
      if (o) {
        var v = o._owner, b = _e(o.type, o._source, v ? v.type : null);
        xt.setExtraStackFrame(b);
      } else
        xt.setExtraStackFrame(null);
    }
    function dn(o, v, b, S, N) {
      {
        var $ = Function.call.bind(De);
        for (var k in o)
          if ($(o, k)) {
            var _ = void 0;
            try {
              if (typeof o[k] != "function") {
                var B = Error((S || "React class") + ": " + b + " type `" + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[k] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw B.name = "Invariant Violation", B;
              }
              _ = o[k](v, k, S, b, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (I) {
              _ = I;
            }
            _ && !(_ instanceof Error) && (ke(N), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", S || "React class", b, k, typeof _), ke(null)), _ instanceof Error && !(_.message in Rt) && (Rt[_.message] = !0, ke(N), w("Failed %s type: %s", b, _.message), ke(null));
          }
      }
    }
    var vn = Array.isArray;
    function Ke(o) {
      return vn(o);
    }
    function hn(o) {
      {
        var v = typeof Symbol == "function" && Symbol.toStringTag, b = v && o[Symbol.toStringTag] || o.constructor.name || "Object";
        return b;
      }
    }
    function pn(o) {
      try {
        return Tt(o), !1;
      } catch {
        return !0;
      }
    }
    function Tt(o) {
      return "" + o;
    }
    function Pt(o) {
      if (pn(o))
        return w("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", hn(o)), Tt(o);
    }
    var pe = C.ReactCurrentOwner, mn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ot, _t, qe;
    qe = {};
    function gn(o) {
      if (De.call(o, "ref")) {
        var v = Object.getOwnPropertyDescriptor(o, "ref").get;
        if (v && v.isReactWarning)
          return !1;
      }
      return o.ref !== void 0;
    }
    function bn(o) {
      if (De.call(o, "key")) {
        var v = Object.getOwnPropertyDescriptor(o, "key").get;
        if (v && v.isReactWarning)
          return !1;
      }
      return o.key !== void 0;
    }
    function yn(o, v) {
      if (typeof o.ref == "string" && pe.current && v && pe.current.stateNode !== v) {
        var b = X(pe.current.type);
        qe[b] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', X(pe.current.type), o.ref), qe[b] = !0);
      }
    }
    function En(o, v) {
      {
        var b = function() {
          Ot || (Ot = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", v));
        };
        b.isReactWarning = !0, Object.defineProperty(o, "key", {
          get: b,
          configurable: !0
        });
      }
    }
    function Cn(o, v) {
      {
        var b = function() {
          _t || (_t = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", v));
        };
        b.isReactWarning = !0, Object.defineProperty(o, "ref", {
          get: b,
          configurable: !0
        });
      }
    }
    var wn = function(o, v, b, S, N, $, k) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: o,
        key: v,
        ref: b,
        props: k,
        // Record the component responsible for creating this element.
        _owner: $
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: S
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: N
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function Sn(o, v, b, S, N) {
      {
        var $, k = {}, _ = null, B = null;
        b !== void 0 && (Pt(b), _ = "" + b), bn(v) && (Pt(v.key), _ = "" + v.key), gn(v) && (B = v.ref, yn(v, N));
        for ($ in v)
          De.call(v, $) && !mn.hasOwnProperty($) && (k[$] = v[$]);
        if (o && o.defaultProps) {
          var I = o.defaultProps;
          for ($ in I)
            k[$] === void 0 && (k[$] = I[$]);
        }
        if (_ || B) {
          var M = typeof o == "function" ? o.displayName || o.name || "Unknown" : o;
          _ && En(k, M), B && Cn(k, M);
        }
        return wn(o, _, B, N, S, pe.current, k);
      }
    }
    var Je = C.ReactCurrentOwner, Dt = C.ReactDebugCurrentFrame;
    function ne(o) {
      if (o) {
        var v = o._owner, b = _e(o.type, o._source, v ? v.type : null);
        Dt.setExtraStackFrame(b);
      } else
        Dt.setExtraStackFrame(null);
    }
    var Ze;
    Ze = !1;
    function Qe(o) {
      return typeof o == "object" && o !== null && o.$$typeof === t;
    }
    function kt() {
      {
        if (Je.current) {
          var o = X(Je.current.type);
          if (o)
            return `

Check the render method of \`` + o + "`.";
        }
        return "";
      }
    }
    function Rn(o) {
      return "";
    }
    var Nt = {};
    function xn(o) {
      {
        var v = kt();
        if (!v) {
          var b = typeof o == "string" ? o : o.displayName || o.name;
          b && (v = `

Check the top-level render call using <` + b + ">.");
        }
        return v;
      }
    }
    function $t(o, v) {
      {
        if (!o._store || o._store.validated || o.key != null)
          return;
        o._store.validated = !0;
        var b = xn(v);
        if (Nt[b])
          return;
        Nt[b] = !0;
        var S = "";
        o && o._owner && o._owner !== Je.current && (S = " It was passed a child from " + X(o._owner.type) + "."), ne(o), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', b, S), ne(null);
      }
    }
    function At(o, v) {
      {
        if (typeof o != "object")
          return;
        if (Ke(o))
          for (var b = 0; b < o.length; b++) {
            var S = o[b];
            Qe(S) && $t(S, v);
          }
        else if (Qe(o))
          o._store && (o._store.validated = !0);
        else if (o) {
          var N = g(o);
          if (typeof N == "function" && N !== o.entries)
            for (var $ = N.call(o), k; !(k = $.next()).done; )
              Qe(k.value) && $t(k.value, v);
        }
      }
    }
    function Tn(o) {
      {
        var v = o.type;
        if (v == null || typeof v == "string")
          return;
        var b;
        if (typeof v == "function")
          b = v.propTypes;
        else if (typeof v == "object" && (v.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        v.$$typeof === h))
          b = v.propTypes;
        else
          return;
        if (b) {
          var S = X(v);
          dn(b, o.props, "prop", S, o);
        } else if (v.PropTypes !== void 0 && !Ze) {
          Ze = !0;
          var N = X(v);
          w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", N || "Unknown");
        }
        typeof v.getDefaultProps == "function" && !v.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Pn(o) {
      {
        for (var v = Object.keys(o.props), b = 0; b < v.length; b++) {
          var S = v[b];
          if (S !== "children" && S !== "key") {
            ne(o), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", S), ne(null);
            break;
          }
        }
        o.ref !== null && (ne(o), w("Invalid attribute `ref` supplied to `React.Fragment`."), ne(null));
      }
    }
    function It(o, v, b, S, N, $) {
      {
        var k = Q(o);
        if (!k) {
          var _ = "";
          (o === void 0 || typeof o == "object" && o !== null && Object.keys(o).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var B = Rn();
          B ? _ += B : _ += kt();
          var I;
          o === null ? I = "null" : Ke(o) ? I = "array" : o !== void 0 && o.$$typeof === t ? (I = "<" + (X(o.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : I = typeof o, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", I, _);
        }
        var M = Sn(o, v, b, N, $);
        if (M == null)
          return M;
        if (k) {
          var G = v.children;
          if (G !== void 0)
            if (S)
              if (Ke(G)) {
                for (var oe = 0; oe < G.length; oe++)
                  At(G[oe], o);
                Object.freeze && Object.freeze(G);
              } else
                w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              At(G, o);
        }
        return o === n ? Pn(M) : Tn(M), M;
      }
    }
    function On(o, v, b) {
      return It(o, v, b, !0);
    }
    function _n(o, v, b) {
      return It(o, v, b, !1);
    }
    var Dn = _n, kn = On;
    ge.Fragment = n, ge.jsx = Dn, ge.jsxs = kn;
  }()), ge;
}
process.env.NODE_ENV === "production" ? ft.exports = Vn() : ft.exports = Hn();
var m = ft.exports;
function ye(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), r === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function Yn(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Gn(...e) {
  return (t) => e.forEach((r) => Yn(r, t));
}
function We(...e) {
  return s.useCallback(Gn(...e), e);
}
function Xn(e, t) {
  const r = s.createContext(t);
  function n(i) {
    const { children: u, ...c } = i, f = s.useMemo(() => c, Object.values(c));
    return /* @__PURE__ */ m.jsx(r.Provider, { value: f, children: u });
  }
  function a(i) {
    const u = s.useContext(r);
    if (u) return u;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return n.displayName = e + "Provider", [n, a];
}
function zn(e, t = []) {
  let r = [];
  function n(i, u) {
    const c = s.createContext(u), f = r.length;
    r = [...r, u];
    function d(h) {
      const { scope: y, children: E, ...T } = h, l = (y == null ? void 0 : y[e][f]) || c, g = s.useMemo(() => T, Object.values(T));
      return /* @__PURE__ */ m.jsx(l.Provider, { value: g, children: E });
    }
    function p(h, y) {
      const E = (y == null ? void 0 : y[e][f]) || c, T = s.useContext(E);
      if (T) return T;
      if (u !== void 0) return u;
      throw new Error(`\`${h}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, p];
  }
  const a = () => {
    const i = r.map((u) => s.createContext(u));
    return function(c) {
      const f = (c == null ? void 0 : c[e]) || i;
      return s.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: f } }),
        [c, f]
      );
    };
  };
  return a.scopeName = e, [n, Kn(a, ...t)];
}
function Kn(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(i) {
      const u = n.reduce((c, { useScope: f, scopeName: d }) => {
        const h = f(i)[`__scope${d}`];
        return { ...c, ...h };
      }, {});
      return s.useMemo(() => ({ [`__scope${t.scopeName}`]: u }), [u]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
var qn = globalThis != null && globalThis.document ? s.useLayoutEffect : () => {
}, Jn = s.useId || (() => {
}), Zn = 0;
function tt(e) {
  const [t, r] = s.useState(Jn());
  return qn(() => {
    e || r((n) => n ?? String(Zn++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function sr(e) {
  const t = s.useRef(e);
  return s.useEffect(() => {
    t.current = e;
  }), s.useMemo(() => (...r) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...r);
  }, []);
}
function Qn({
  prop: e,
  defaultProp: t,
  onChange: r = () => {
  }
}) {
  const [n, a] = eo({ defaultProp: t, onChange: r }), i = e !== void 0, u = i ? e : n, c = sr(r), f = s.useCallback(
    (d) => {
      if (i) {
        const h = typeof d == "function" ? d(e) : d;
        h !== e && c(h);
      } else
        a(d);
    },
    [i, e, a, c]
  );
  return [u, f];
}
function eo({
  defaultProp: e,
  onChange: t
}) {
  const r = s.useState(e), [n] = r, a = s.useRef(n), i = sr(t);
  return s.useEffect(() => {
    a.current !== n && (i(n), a.current = n);
  }, [n, a, i]), r;
}
function rt(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), r === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function to(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function ro(...e) {
  return (t) => e.forEach((r) => to(r, t));
}
var de = s.forwardRef((e, t) => {
  const { children: r, ...n } = e, a = s.Children.toArray(r), i = a.find(oo);
  if (i) {
    const u = i.props.children, c = a.map((f) => f === i ? s.Children.count(u) > 1 ? s.Children.only(null) : s.isValidElement(u) ? u.props.children : null : f);
    return /* @__PURE__ */ m.jsx(dt, { ...n, ref: t, children: s.isValidElement(u) ? s.cloneElement(u, void 0, c) : null });
  }
  return /* @__PURE__ */ m.jsx(dt, { ...n, ref: t, children: r });
});
de.displayName = "Slot";
var dt = s.forwardRef((e, t) => {
  const { children: r, ...n } = e;
  if (s.isValidElement(r)) {
    const a = io(r);
    return s.cloneElement(r, {
      ...ao(n, r.props),
      // @ts-ignore
      ref: t ? ro(t, a) : a
    });
  }
  return s.Children.count(r) > 1 ? s.Children.only(null) : null;
});
dt.displayName = "SlotClone";
var no = ({ children: e }) => /* @__PURE__ */ m.jsx(m.Fragment, { children: e });
function oo(e) {
  return s.isValidElement(e) && e.type === no;
}
function ao(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], i = t[n];
    /^on[A-Z]/.test(n) ? a && i ? r[n] = (...c) => {
      i(...c), a(...c);
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...i } : n === "className" && (r[n] = [a, i].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function io(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var so = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], cr = so.reduce((e, t) => {
  const r = s.forwardRef((n, a) => {
    const { asChild: i, ...u } = n, c = i ? de : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m.jsx(c, { ...u, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function co(e, t) {
  e && ir.flushSync(() => e.dispatchEvent(t));
}
function uo(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function lo(...e) {
  return (t) => e.forEach((r) => uo(r, t));
}
function ur(...e) {
  return s.useCallback(lo(...e), e);
}
function lr(e) {
  const t = s.useRef(e);
  return s.useEffect(() => {
    t.current = e;
  }), s.useMemo(() => (...r) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...r);
  }, []);
}
function fo(e) {
  const t = s.useRef(e);
  return s.useEffect(() => {
    t.current = e;
  }), s.useMemo(() => (...r) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...r);
  }, []);
}
function vo(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = fo(e);
  s.useEffect(() => {
    const n = (a) => {
      a.key === "Escape" && r(a);
    };
    return t.addEventListener("keydown", n, { capture: !0 }), () => t.removeEventListener("keydown", n, { capture: !0 });
  }, [r, t]);
}
var ho = "DismissableLayer", vt = "dismissableLayer.update", po = "dismissableLayer.pointerDownOutside", mo = "dismissableLayer.focusOutside", Ft, fr = s.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), dr = s.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: a,
      onFocusOutside: i,
      onInteractOutside: u,
      onDismiss: c,
      ...f
    } = e, d = s.useContext(fr), [p, h] = s.useState(null), y = (p == null ? void 0 : p.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, E] = s.useState({}), T = ur(t, (D) => h(D)), l = Array.from(d.layers), [g] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), C = l.indexOf(g), w = p ? l.indexOf(p) : -1, x = d.layersWithOutsidePointerEventsDisabled.size > 0, O = w >= C, R = yo((D) => {
      const F = D.target, V = [...d.branches].some((Q) => Q.contains(F));
      !O || V || (a == null || a(D), u == null || u(D), D.defaultPrevented || c == null || c());
    }, y), j = Eo((D) => {
      const F = D.target;
      [...d.branches].some((Q) => Q.contains(F)) || (i == null || i(D), u == null || u(D), D.defaultPrevented || c == null || c());
    }, y);
    return vo((D) => {
      w === d.layers.size - 1 && (n == null || n(D), !D.defaultPrevented && c && (D.preventDefault(), c()));
    }, y), s.useEffect(() => {
      if (p)
        return r && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (Ft = y.body.style.pointerEvents, y.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(p)), d.layers.add(p), Wt(), () => {
          r && d.layersWithOutsidePointerEventsDisabled.size === 1 && (y.body.style.pointerEvents = Ft);
        };
    }, [p, y, r, d]), s.useEffect(() => () => {
      p && (d.layers.delete(p), d.layersWithOutsidePointerEventsDisabled.delete(p), Wt());
    }, [p, d]), s.useEffect(() => {
      const D = () => E({});
      return document.addEventListener(vt, D), () => document.removeEventListener(vt, D);
    }, []), /* @__PURE__ */ m.jsx(
      cr.div,
      {
        ...f,
        ref: T,
        style: {
          pointerEvents: x ? O ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: rt(e.onFocusCapture, j.onFocusCapture),
        onBlurCapture: rt(e.onBlurCapture, j.onBlurCapture),
        onPointerDownCapture: rt(
          e.onPointerDownCapture,
          R.onPointerDownCapture
        )
      }
    );
  }
);
dr.displayName = ho;
var go = "DismissableLayerBranch", bo = s.forwardRef((e, t) => {
  const r = s.useContext(fr), n = s.useRef(null), a = ur(t, n);
  return s.useEffect(() => {
    const i = n.current;
    if (i)
      return r.branches.add(i), () => {
        r.branches.delete(i);
      };
  }, [r.branches]), /* @__PURE__ */ m.jsx(cr.div, { ...e, ref: a });
});
bo.displayName = go;
function yo(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = lr(e), n = s.useRef(!1), a = s.useRef(() => {
  });
  return s.useEffect(() => {
    const i = (c) => {
      if (c.target && !n.current) {
        let f = function() {
          vr(
            po,
            r,
            d,
            { discrete: !0 }
          );
        };
        const d = { originalEvent: c };
        c.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = f, t.addEventListener("click", a.current, { once: !0 })) : f();
      } else
        t.removeEventListener("click", a.current);
      n.current = !1;
    }, u = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(u), t.removeEventListener("pointerdown", i), t.removeEventListener("click", a.current);
    };
  }, [t, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function Eo(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = lr(e), n = s.useRef(!1);
  return s.useEffect(() => {
    const a = (i) => {
      i.target && !n.current && vr(mo, r, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [t, r]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function Wt() {
  const e = new CustomEvent(vt);
  document.dispatchEvent(e);
}
function vr(e, t, r, { discrete: n }) {
  const a = r.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  t && a.addEventListener(e, t, { once: !0 }), n ? co(a, i) : a.dispatchEvent(i);
}
function Co(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function wo(...e) {
  return (t) => e.forEach((r) => Co(r, t));
}
function So(...e) {
  return s.useCallback(wo(...e), e);
}
var Ro = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], xo = Ro.reduce((e, t) => {
  const r = s.forwardRef((n, a) => {
    const { asChild: i, ...u } = n, c = i ? de : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m.jsx(c, { ...u, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Bt(e) {
  const t = s.useRef(e);
  return s.useEffect(() => {
    t.current = e;
  }), s.useMemo(() => (...r) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...r);
  }, []);
}
var nt = "focusScope.autoFocusOnMount", ot = "focusScope.autoFocusOnUnmount", Ut = { bubbles: !1, cancelable: !0 }, To = "FocusScope", hr = s.forwardRef((e, t) => {
  const {
    loop: r = !1,
    trapped: n = !1,
    onMountAutoFocus: a,
    onUnmountAutoFocus: i,
    ...u
  } = e, [c, f] = s.useState(null), d = Bt(a), p = Bt(i), h = s.useRef(null), y = So(t, (l) => f(l)), E = s.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  s.useEffect(() => {
    if (n) {
      let l = function(x) {
        if (E.paused || !c) return;
        const O = x.target;
        c.contains(O) ? h.current = O : J(h.current, { select: !0 });
      }, g = function(x) {
        if (E.paused || !c) return;
        const O = x.relatedTarget;
        O !== null && (c.contains(O) || J(h.current, { select: !0 }));
      }, C = function(x) {
        if (document.activeElement === document.body)
          for (const R of x)
            R.removedNodes.length > 0 && J(c);
      };
      document.addEventListener("focusin", l), document.addEventListener("focusout", g);
      const w = new MutationObserver(C);
      return c && w.observe(c, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", l), document.removeEventListener("focusout", g), w.disconnect();
      };
    }
  }, [n, c, E.paused]), s.useEffect(() => {
    if (c) {
      Ht.add(E);
      const l = document.activeElement;
      if (!c.contains(l)) {
        const C = new CustomEvent(nt, Ut);
        c.addEventListener(nt, d), c.dispatchEvent(C), C.defaultPrevented || (Po(No(pr(c)), { select: !0 }), document.activeElement === l && J(c));
      }
      return () => {
        c.removeEventListener(nt, d), setTimeout(() => {
          const C = new CustomEvent(ot, Ut);
          c.addEventListener(ot, p), c.dispatchEvent(C), C.defaultPrevented || J(l ?? document.body, { select: !0 }), c.removeEventListener(ot, p), Ht.remove(E);
        }, 0);
      };
    }
  }, [c, d, p, E]);
  const T = s.useCallback(
    (l) => {
      if (!r && !n || E.paused) return;
      const g = l.key === "Tab" && !l.altKey && !l.ctrlKey && !l.metaKey, C = document.activeElement;
      if (g && C) {
        const w = l.currentTarget, [x, O] = Oo(w);
        x && O ? !l.shiftKey && C === O ? (l.preventDefault(), r && J(x, { select: !0 })) : l.shiftKey && C === x && (l.preventDefault(), r && J(O, { select: !0 })) : C === w && l.preventDefault();
      }
    },
    [r, n, E.paused]
  );
  return /* @__PURE__ */ m.jsx(xo.div, { tabIndex: -1, ...u, ref: y, onKeyDown: T });
});
hr.displayName = To;
function Po(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const n of e)
    if (J(n, { select: t }), document.activeElement !== r) return;
}
function Oo(e) {
  const t = pr(e), r = Vt(t, e), n = Vt(t.reverse(), e);
  return [r, n];
}
function pr(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const a = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || a ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function Vt(e, t) {
  for (const r of e)
    if (!_o(r, { upTo: t })) return r;
}
function _o(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Do(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function J(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== r && Do(e) && t && e.select();
  }
}
var Ht = ko();
function ko() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && (r == null || r.pause()), e = Yt(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = Yt(e, t), (r = e[0]) == null || r.resume();
    }
  };
}
function Yt(e, t) {
  const r = [...e], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function No(e) {
  return e.filter((t) => t.tagName !== "A");
}
var $o = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Ao = $o.reduce((e, t) => {
  const r = s.forwardRef((n, a) => {
    const { asChild: i, ...u } = n, c = i ? de : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m.jsx(c, { ...u, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), Io = globalThis != null && globalThis.document ? s.useLayoutEffect : () => {
}, jo = "Portal", mr = s.forwardRef((e, t) => {
  var c;
  const { container: r, ...n } = e, [a, i] = s.useState(!1);
  Io(() => i(!0), []);
  const u = r || a && ((c = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : c.body);
  return u ? In.createPortal(/* @__PURE__ */ m.jsx(Ao.div, { ...n, ref: t }), u) : null;
});
mr.displayName = jo;
var Gt = globalThis != null && globalThis.document ? s.useLayoutEffect : () => {
};
function Mo(e, t) {
  return s.useReducer((r, n) => t[r][n] ?? r, e);
}
var Be = (e) => {
  const { present: t, children: r } = e, n = Lo(t), a = typeof r == "function" ? r({ present: n.isPresent }) : s.Children.only(r), i = We(n.ref, Fo(a));
  return typeof r == "function" || n.isPresent ? s.cloneElement(a, { ref: i }) : null;
};
Be.displayName = "Presence";
function Lo(e) {
  const [t, r] = s.useState(), n = s.useRef({}), a = s.useRef(e), i = s.useRef("none"), u = e ? "mounted" : "unmounted", [c, f] = Mo(u, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return s.useEffect(() => {
    const d = Ne(n.current);
    i.current = c === "mounted" ? d : "none";
  }, [c]), Gt(() => {
    const d = n.current, p = a.current;
    if (p !== e) {
      const y = i.current, E = Ne(d);
      e ? f("MOUNT") : E === "none" || (d == null ? void 0 : d.display) === "none" ? f("UNMOUNT") : f(p && y !== E ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [e, f]), Gt(() => {
    if (t) {
      const d = (h) => {
        const E = Ne(n.current).includes(h.animationName);
        h.target === t && E && ir.flushSync(() => f("ANIMATION_END"));
      }, p = (h) => {
        h.target === t && (i.current = Ne(n.current));
      };
      return t.addEventListener("animationstart", p), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        t.removeEventListener("animationstart", p), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: s.useCallback((d) => {
      d && (n.current = getComputedStyle(d)), r(d);
    }, [])
  };
}
function Ne(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Fo(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var Wo = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], we = Wo.reduce((e, t) => {
  const r = s.forwardRef((n, a) => {
    const { asChild: i, ...u } = n, c = i ? de : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m.jsx(c, { ...u, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), at = 0;
function Bo() {
  s.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Xt()), document.body.insertAdjacentElement("beforeend", e[1] ?? Xt()), at++, () => {
      at === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), at--;
    };
  }, []);
}
function Xt() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var W = function() {
  return W = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, W.apply(this, arguments);
};
function gt(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}
function gr(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, i; n < a; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Ee = "right-scroll-bar-position", Ce = "width-before-scroll-bar", Uo = "with-scroll-bars-hidden", Vo = "--removed-body-scroll-bar-size";
function it(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Ho(e, t) {
  var r = Z(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var a = r.value;
          a !== n && (r.value = n, r.callback(n, a));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
var Yo = typeof window < "u" ? s.useLayoutEffect : s.useEffect, zt = /* @__PURE__ */ new WeakMap();
function br(e, t) {
  var r = Ho(null, function(n) {
    return e.forEach(function(a) {
      return it(a, n);
    });
  });
  return Yo(function() {
    var n = zt.get(r);
    if (n) {
      var a = new Set(n), i = new Set(e), u = r.current;
      a.forEach(function(c) {
        i.has(c) || it(c, null);
      }), i.forEach(function(c) {
        a.has(c) || it(c, u);
      });
    }
    zt.set(r, e);
  }, [e]), r;
}
function Go(e) {
  return e;
}
function Xo(e, t) {
  t === void 0 && (t = Go);
  var r = [], n = !1, a = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(i) {
      var u = t(i, n);
      return r.push(u), function() {
        r = r.filter(function(c) {
          return c !== u;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (n = !0; r.length; ) {
        var u = r;
        r = [], u.forEach(i);
      }
      r = {
        push: function(c) {
          return i(c);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(i) {
      n = !0;
      var u = [];
      if (r.length) {
        var c = r;
        r = [], c.forEach(i), u = r;
      }
      var f = function() {
        var p = u;
        u = [], p.forEach(i);
      }, d = function() {
        return Promise.resolve().then(f);
      };
      d(), r = {
        push: function(p) {
          u.push(p), d();
        },
        filter: function(p) {
          return u = u.filter(p), r;
        }
      };
    }
  };
  return a;
}
function yr(e) {
  e === void 0 && (e = {});
  var t = Xo(null);
  return t.options = W({ async: !0, ssr: !1 }, e), t;
}
var Er = function(e) {
  var t = e.sideCar, r = gt(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return s.createElement(n, W({}, r));
};
Er.isSideCarExport = !0;
function Cr(e, t) {
  return e.useMedium(t), Er;
}
var wr = yr(), st = function() {
}, Ue = s.forwardRef(function(e, t) {
  var r = s.useRef(null), n = s.useState({
    onScrollCapture: st,
    onWheelCapture: st,
    onTouchMoveCapture: st
  }), a = n[0], i = n[1], u = e.forwardProps, c = e.children, f = e.className, d = e.removeScrollBar, p = e.enabled, h = e.shards, y = e.sideCar, E = e.noIsolation, T = e.inert, l = e.allowPinchZoom, g = e.as, C = g === void 0 ? "div" : g, w = e.gapMode, x = gt(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), O = y, R = br([r, t]), j = W(W({}, x), a);
  return s.createElement(
    s.Fragment,
    null,
    p && s.createElement(O, { sideCar: wr, removeScrollBar: d, shards: h, noIsolation: E, inert: T, setCallbacks: i, allowPinchZoom: !!l, lockRef: r, gapMode: w }),
    u ? s.cloneElement(s.Children.only(c), W(W({}, j), { ref: R })) : s.createElement(C, W({}, j, { className: f, ref: R }), c)
  );
});
Ue.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Ue.classNames = {
  fullWidth: Ce,
  zeroRight: Ee
};
var zo = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Ko() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = zo();
  return t && e.setAttribute("nonce", t), e;
}
function qo(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Jo(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Zo = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = Ko()) && (qo(t, r), Jo(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Qo = function() {
  var e = Zo();
  return function(t, r) {
    s.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, bt = function() {
  var e = Qo(), t = function(r) {
    var n = r.styles, a = r.dynamic;
    return e(n, a), null;
  };
  return t;
}, ea = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, ct = function(e) {
  return parseInt(e || "", 10) || 0;
}, ta = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [ct(r), ct(n), ct(a)];
}, ra = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return ea;
  var t = ta(e), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - r + t[2] - t[0])
  };
}, na = bt(), fe = "data-scroll-locked", oa = function(e, t, r, n) {
  var a = e.left, i = e.top, u = e.right, c = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(Uo, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(c, "px ").concat(n, `;
  }
  body[`).concat(fe, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(u, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(c, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(c, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Ee, ` {
    right: `).concat(c, "px ").concat(n, `;
  }
  
  .`).concat(Ce, ` {
    margin-right: `).concat(c, "px ").concat(n, `;
  }
  
  .`).concat(Ee, " .").concat(Ee, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(Ce, " .").concat(Ce, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(fe, `] {
    `).concat(Vo, ": ").concat(c, `px;
  }
`);
}, Kt = function() {
  var e = parseInt(document.body.getAttribute(fe) || "0", 10);
  return isFinite(e) ? e : 0;
}, aa = function() {
  s.useEffect(function() {
    return document.body.setAttribute(fe, (Kt() + 1).toString()), function() {
      var e = Kt() - 1;
      e <= 0 ? document.body.removeAttribute(fe) : document.body.setAttribute(fe, e.toString());
    };
  }, []);
}, Sr = function(e) {
  var t = e.noRelative, r = e.noImportant, n = e.gapMode, a = n === void 0 ? "margin" : n;
  aa();
  var i = s.useMemo(function() {
    return ra(a);
  }, [a]);
  return s.createElement(na, { styles: oa(i, !t, a, r ? "" : "!important") });
}, ht = !1;
if (typeof window < "u")
  try {
    var $e = Object.defineProperty({}, "passive", {
      get: function() {
        return ht = !0, !0;
      }
    });
    window.addEventListener("test", $e, $e), window.removeEventListener("test", $e, $e);
  } catch {
    ht = !1;
  }
var ie = ht ? { passive: !1 } : !1, ia = function(e) {
  return e.tagName === "TEXTAREA";
}, Rr = function(e, t) {
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !ia(e) && r[t] === "visible")
  );
}, sa = function(e) {
  return Rr(e, "overflowY");
}, ca = function(e) {
  return Rr(e, "overflowX");
}, qt = function(e, t) {
  var r = t.ownerDocument, n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var a = xr(e, n);
    if (a) {
      var i = Tr(e, n), u = i[1], c = i[2];
      if (u > c)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, ua = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, la = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, xr = function(e, t) {
  return e === "v" ? sa(t) : ca(t);
}, Tr = function(e, t) {
  return e === "v" ? ua(t) : la(t);
}, fa = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, da = function(e, t, r, n, a) {
  var i = fa(e, window.getComputedStyle(t).direction), u = i * n, c = r.target, f = t.contains(c), d = !1, p = u > 0, h = 0, y = 0;
  do {
    var E = Tr(e, c), T = E[0], l = E[1], g = E[2], C = l - g - i * T;
    (T || C) && xr(e, c) && (h += C, y += T), c instanceof ShadowRoot ? c = c.host : c = c.parentNode;
  } while (
    // portaled content
    !f && c !== document.body || // self content
    f && (t.contains(c) || t === c)
  );
  return (p && (Math.abs(h) < 1 || !a) || !p && (Math.abs(y) < 1 || !a)) && (d = !0), d;
}, Ae = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Jt = function(e) {
  return [e.deltaX, e.deltaY];
}, Zt = function(e) {
  return e && "current" in e ? e.current : e;
}, va = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, ha = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, pa = 0, se = [];
function ma(e) {
  var t = s.useRef([]), r = s.useRef([0, 0]), n = s.useRef(), a = s.useState(pa++)[0], i = s.useState(bt)[0], u = s.useRef(e);
  s.useEffect(function() {
    u.current = e;
  }, [e]), s.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var l = gr([e.lockRef.current], (e.shards || []).map(Zt), !0).filter(Boolean);
      return l.forEach(function(g) {
        return g.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), l.forEach(function(g) {
          return g.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var c = s.useCallback(function(l, g) {
    if ("touches" in l && l.touches.length === 2)
      return !u.current.allowPinchZoom;
    var C = Ae(l), w = r.current, x = "deltaX" in l ? l.deltaX : w[0] - C[0], O = "deltaY" in l ? l.deltaY : w[1] - C[1], R, j = l.target, D = Math.abs(x) > Math.abs(O) ? "h" : "v";
    if ("touches" in l && D === "h" && j.type === "range")
      return !1;
    var F = qt(D, j);
    if (!F)
      return !0;
    if (F ? R = D : (R = D === "v" ? "h" : "v", F = qt(D, j)), !F)
      return !1;
    if (!n.current && "changedTouches" in l && (x || O) && (n.current = R), !R)
      return !0;
    var V = n.current || R;
    return da(V, g, l, V === "h" ? x : O, !0);
  }, []), f = s.useCallback(function(l) {
    var g = l;
    if (!(!se.length || se[se.length - 1] !== i)) {
      var C = "deltaY" in g ? Jt(g) : Ae(g), w = t.current.filter(function(R) {
        return R.name === g.type && (R.target === g.target || g.target === R.shadowParent) && va(R.delta, C);
      })[0];
      if (w && w.should) {
        g.cancelable && g.preventDefault();
        return;
      }
      if (!w) {
        var x = (u.current.shards || []).map(Zt).filter(Boolean).filter(function(R) {
          return R.contains(g.target);
        }), O = x.length > 0 ? c(g, x[0]) : !u.current.noIsolation;
        O && g.cancelable && g.preventDefault();
      }
    }
  }, []), d = s.useCallback(function(l, g, C, w) {
    var x = { name: l, delta: g, target: C, should: w, shadowParent: ga(C) };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(O) {
        return O !== x;
      });
    }, 1);
  }, []), p = s.useCallback(function(l) {
    r.current = Ae(l), n.current = void 0;
  }, []), h = s.useCallback(function(l) {
    d(l.type, Jt(l), l.target, c(l, e.lockRef.current));
  }, []), y = s.useCallback(function(l) {
    d(l.type, Ae(l), l.target, c(l, e.lockRef.current));
  }, []);
  s.useEffect(function() {
    return se.push(i), e.setCallbacks({
      onScrollCapture: h,
      onWheelCapture: h,
      onTouchMoveCapture: y
    }), document.addEventListener("wheel", f, ie), document.addEventListener("touchmove", f, ie), document.addEventListener("touchstart", p, ie), function() {
      se = se.filter(function(l) {
        return l !== i;
      }), document.removeEventListener("wheel", f, ie), document.removeEventListener("touchmove", f, ie), document.removeEventListener("touchstart", p, ie);
    };
  }, []);
  var E = e.removeScrollBar, T = e.inert;
  return s.createElement(
    s.Fragment,
    null,
    T ? s.createElement(i, { styles: ha(a) }) : null,
    E ? s.createElement(Sr, { gapMode: e.gapMode }) : null
  );
}
function ga(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const ba = Cr(wr, ma);
var Pr = s.forwardRef(function(e, t) {
  return s.createElement(Ue, W({}, e, { ref: t, sideCar: ba }));
});
Pr.classNames = Ue.classNames;
var ya = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, ce = /* @__PURE__ */ new WeakMap(), Ie = /* @__PURE__ */ new WeakMap(), je = {}, ut = 0, Or = function(e) {
  return e && (e.host || Or(e.parentNode));
}, Ea = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var n = Or(r);
    return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, Ca = function(e, t, r, n) {
  var a = Ea(t, Array.isArray(e) ? e : [e]);
  je[r] || (je[r] = /* @__PURE__ */ new WeakMap());
  var i = je[r], u = [], c = /* @__PURE__ */ new Set(), f = new Set(a), d = function(h) {
    !h || c.has(h) || (c.add(h), d(h.parentNode));
  };
  a.forEach(d);
  var p = function(h) {
    !h || f.has(h) || Array.prototype.forEach.call(h.children, function(y) {
      if (c.has(y))
        p(y);
      else
        try {
          var E = y.getAttribute(n), T = E !== null && E !== "false", l = (ce.get(y) || 0) + 1, g = (i.get(y) || 0) + 1;
          ce.set(y, l), i.set(y, g), u.push(y), l === 1 && T && Ie.set(y, !0), g === 1 && y.setAttribute(r, "true"), T || y.setAttribute(n, "true");
        } catch (C) {
          console.error("aria-hidden: cannot operate on ", y, C);
        }
    });
  };
  return p(t), c.clear(), ut++, function() {
    u.forEach(function(h) {
      var y = ce.get(h) - 1, E = i.get(h) - 1;
      ce.set(h, y), i.set(h, E), y || (Ie.has(h) || h.removeAttribute(n), Ie.delete(h)), E || h.removeAttribute(r);
    }), ut--, ut || (ce = /* @__PURE__ */ new WeakMap(), ce = /* @__PURE__ */ new WeakMap(), Ie = /* @__PURE__ */ new WeakMap(), je = {});
  };
}, wa = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), a = ya(e);
  return a ? (n.push.apply(n, Array.from(a.querySelectorAll("[aria-live]"))), Ca(n, a, r, "aria-hidden")) : function() {
    return null;
  };
}, yt = "Dialog", [_r, Di] = zn(yt), [Sa, z] = _r(yt), Dr = (e) => {
  const {
    __scopeDialog: t,
    children: r,
    open: n,
    defaultOpen: a,
    onOpenChange: i,
    modal: u = !0
  } = e, c = s.useRef(null), f = s.useRef(null), [d = !1, p] = Qn({
    prop: n,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ m.jsx(
    Sa,
    {
      scope: t,
      triggerRef: c,
      contentRef: f,
      contentId: tt(),
      titleId: tt(),
      descriptionId: tt(),
      open: d,
      onOpenChange: p,
      onOpenToggle: s.useCallback(() => p((h) => !h), [p]),
      modal: u,
      children: r
    }
  );
};
Dr.displayName = yt;
var kr = "DialogTrigger", Nr = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, a = z(kr, r), i = We(t, a.triggerRef);
    return /* @__PURE__ */ m.jsx(
      we.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": wt(a.open),
        ...n,
        ref: i,
        onClick: ye(e.onClick, a.onOpenToggle)
      }
    );
  }
);
Nr.displayName = kr;
var Et = "DialogPortal", [Ra, $r] = _r(Et, {
  forceMount: void 0
}), Ar = (e) => {
  const { __scopeDialog: t, forceMount: r, children: n, container: a } = e, i = z(Et, t);
  return /* @__PURE__ */ m.jsx(Ra, { scope: t, forceMount: r, children: s.Children.map(n, (u) => /* @__PURE__ */ m.jsx(Be, { present: r || i.open, children: /* @__PURE__ */ m.jsx(mr, { asChild: !0, container: a, children: u }) })) });
};
Ar.displayName = Et;
var Fe = "DialogOverlay", xa = s.forwardRef(
  (e, t) => {
    const r = $r(Fe, e.__scopeDialog), { forceMount: n = r.forceMount, ...a } = e, i = z(Fe, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ m.jsx(Be, { present: n || i.open, children: /* @__PURE__ */ m.jsx(Ta, { ...a, ref: t }) }) : null;
  }
);
xa.displayName = Fe;
var Ta = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, a = z(Fe, r);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ m.jsx(Pr, { as: de, allowPinchZoom: !0, shards: [a.contentRef], children: /* @__PURE__ */ m.jsx(
        we.div,
        {
          "data-state": wt(a.open),
          ...n,
          ref: t,
          style: { pointerEvents: "auto", ...n.style }
        }
      ) })
    );
  }
), te = "DialogContent", Ir = s.forwardRef(
  (e, t) => {
    const r = $r(te, e.__scopeDialog), { forceMount: n = r.forceMount, ...a } = e, i = z(te, e.__scopeDialog);
    return /* @__PURE__ */ m.jsx(Be, { present: n || i.open, children: i.modal ? /* @__PURE__ */ m.jsx(Pa, { ...a, ref: t }) : /* @__PURE__ */ m.jsx(Oa, { ...a, ref: t }) });
  }
);
Ir.displayName = te;
var Pa = s.forwardRef(
  (e, t) => {
    const r = z(te, e.__scopeDialog), n = s.useRef(null), a = We(t, r.contentRef, n);
    return s.useEffect(() => {
      const i = n.current;
      if (i) return wa(i);
    }, []), /* @__PURE__ */ m.jsx(
      jr,
      {
        ...e,
        ref: a,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: ye(e.onCloseAutoFocus, (i) => {
          var u;
          i.preventDefault(), (u = r.triggerRef.current) == null || u.focus();
        }),
        onPointerDownOutside: ye(e.onPointerDownOutside, (i) => {
          const u = i.detail.originalEvent, c = u.button === 0 && u.ctrlKey === !0;
          (u.button === 2 || c) && i.preventDefault();
        }),
        onFocusOutside: ye(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), Oa = s.forwardRef(
  (e, t) => {
    const r = z(te, e.__scopeDialog), n = s.useRef(!1), a = s.useRef(!1);
    return /* @__PURE__ */ m.jsx(
      jr,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var u, c;
          (u = e.onCloseAutoFocus) == null || u.call(e, i), i.defaultPrevented || (n.current || (c = r.triggerRef.current) == null || c.focus(), i.preventDefault()), n.current = !1, a.current = !1;
        },
        onInteractOutside: (i) => {
          var f, d;
          (f = e.onInteractOutside) == null || f.call(e, i), i.defaultPrevented || (n.current = !0, i.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const u = i.target;
          ((d = r.triggerRef.current) == null ? void 0 : d.contains(u)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && a.current && i.preventDefault();
        }
      }
    );
  }
), jr = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, trapFocus: n, onOpenAutoFocus: a, onCloseAutoFocus: i, ...u } = e, c = z(te, r), f = s.useRef(null), d = We(t, f);
    return Bo(), /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
      /* @__PURE__ */ m.jsx(
        hr,
        {
          asChild: !0,
          loop: !0,
          trapped: n,
          onMountAutoFocus: a,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ m.jsx(
            dr,
            {
              role: "dialog",
              id: c.contentId,
              "aria-describedby": c.descriptionId,
              "aria-labelledby": c.titleId,
              "data-state": wt(c.open),
              ...u,
              ref: d,
              onDismiss: () => c.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
        /* @__PURE__ */ m.jsx(_a, { titleId: c.titleId }),
        /* @__PURE__ */ m.jsx(ka, { contentRef: f, descriptionId: c.descriptionId })
      ] })
    ] });
  }
), Ct = "DialogTitle", Mr = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, a = z(Ct, r);
    return /* @__PURE__ */ m.jsx(we.h2, { id: a.titleId, ...n, ref: t });
  }
);
Mr.displayName = Ct;
var Lr = "DialogDescription", Fr = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, a = z(Lr, r);
    return /* @__PURE__ */ m.jsx(we.p, { id: a.descriptionId, ...n, ref: t });
  }
);
Fr.displayName = Lr;
var Wr = "DialogClose", Br = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, a = z(Wr, r);
    return /* @__PURE__ */ m.jsx(
      we.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: ye(e.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
Br.displayName = Wr;
function wt(e) {
  return e ? "open" : "closed";
}
var Ur = "DialogTitleWarning", [ki, Vr] = Xn(Ur, {
  contentName: te,
  titleName: Ct,
  docsSlug: "dialog"
}), _a = ({ titleId: e }) => {
  const t = Vr(Ur), r = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return s.useEffect(() => {
    e && (document.getElementById(e) || console.error(r));
  }, [r, e]), null;
}, Da = "DialogDescriptionWarning", ka = ({ contentRef: e, descriptionId: t }) => {
  const n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Vr(Da).contentName}}.`;
  return s.useEffect(() => {
    var i;
    const a = (i = e.current) == null ? void 0 : i.getAttribute("aria-describedby");
    t && a && (document.getElementById(t) || console.warn(n));
  }, [n, e, t]), null;
}, Na = Dr, Qt = Nr, $a = Ar, Aa = Ir, Ia = Mr, ja = Fr, Ma = Br;
const Hr = Nn({}), La = ({
  children: e,
  size: t = "medium",
  ...r
}) => /* @__PURE__ */ m.jsx(Hr.Provider, { value: { size: t }, children: /* @__PURE__ */ m.jsx(Na, { ...r, modal: !1, children: e }) }), Fa = () => {
  const e = $n(Hr);
  if (!e)
    throw new Error("useModalContext must be used within a RootProvider");
  return e;
}, Yr = ({ children: e }) => /* @__PURE__ */ m.jsx(ja, { asChild: !0, children: /* @__PURE__ */ m.jsx(mt, { variant: "body4", color: "neutral.40", children: e }) }), Wa = L.div`
  border-radius: ${({ theme: e }) => e.borders.radius.l};
  overflow: hidden;
  width: 100%;
  height: 200px;
  position: relative;
  background: transparent;

  display: flex;
  align-items: center;
  justify-content: center;

  & img,
  & video {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
`, Gr = ({ children: e, imgUrl: t, videoUrl: r }) => /* @__PURE__ */ m.jsx(Wa, { children: e || (t ? /* @__PURE__ */ m.jsx("img", { alt: "Cover", src: t }) : r && /* @__PURE__ */ m.jsx("img", { alt: "Video", src: t })) }), Ba = L.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme: e }) => e.spacings.xs5};
  font-weight: 700;

  ${({ compact: e }) => e && `
    align-items: center;
    flex-direction: row;
    `}
`, Xr = ({
  customIconName: e,
  size: t = "default",
  type: r = "announcement",
  children: n
}) => {
  const a = Bn(), i = ae(
    () => ({
      announcement: "secondary.50",
      error: "status.negative.40",
      success: "feedback.success.40",
      warning: "feedback.error.40"
    })[r],
    [r]
  ), u = ae(
    () => ({
      announcement: a.colors.secondary[50],
      error: a.colors.status.negative[40],
      success: a.colors.feedback.success[40],
      warning: a.colors.feedback.error[40]
    })[r],
    [r]
  ), c = ae(
    () => ({
      default: 48,
      compact: 24
    })[t],
    [t]
  ), f = ae(
    () => e ?? {
      announcement: "IconSparkles",
      error: "IconCircleX",
      success: "IconCircleCheck",
      warning: "IconAlertCircle"
    }[r],
    [r]
  ), d = ae(
    () => ({
      default: jn,
      compact: Mn
    })[t],
    [t]
  ), p = ae(
    () => ({
      default: {
        announcement: "default",
        error: "negative",
        success: "success",
        warning: "error"
      },
      compact: void 0
    })[t],
    [t]
  );
  return /* @__PURE__ */ m.jsxs(Ba, { compact: t === "compact", children: [
    d && /* @__PURE__ */ m.jsx(
      d,
      {
        "aria-hidden": !0,
        name: f,
        size: c,
        color: u,
        variant: (p == null ? void 0 : p[r]) ?? "default"
      }
    ),
    /* @__PURE__ */ m.jsx(mt, { variant: "body4", color: i, weight: 700, children: n })
  ] });
}, zr = ({ children: e }) => /* @__PURE__ */ m.jsx(Ia, { asChild: !0, children: /* @__PURE__ */ m.jsx(mt, { variant: "headline8", children: e }) });
var Ve = /* @__PURE__ */ ((e) => (e[e.Overlay = 1200] = "Overlay", e[e.Content = 1201] = "Content", e[e.CloseButton = 1202] = "CloseButton", e))(Ve || {}), be = /* @__PURE__ */ ((e) => (e.OutsideTopRight = "OUTSIDE_TOP_RIGHT", e.InsideTopRight = "INSIDE_TOP_RIGHT", e.OutsideRightTop = "OUTSIDE_RIGHT_TOP", e))(be || {});
const Ua = L.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: ${Ve.CloseButton};
  margin: ${({ theme: e }) => e.spacings.xs3};
  pointer-events: all;

  ${({ position: e }) => ({
  INSIDE_TOP_RIGHT: "",
  OUTSIDE_RIGHT_TOP: "transform: translateX(175%);",
  OUTSIDE_TOP_RIGHT: "transform: translate(25%, -175%)"
})[e]}
`, Va = L.div`
  margin: 8px 0 24px 0;
`, Ha = L.div`
  margin: 12px 0 8px 0;
`, Kr = L.div`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 8px;
  opacity: 0;
  transition: opacity 0.2s ease;
  overflow: auto;

  height: ${({ height: e }) => e};

  &:hover {
    opacity: 1;
  }

  /* Scrollbar for Chrome, Safari, Opera, and Edge */
  &::-webkit-scrollbar {
    background-color: ${({ theme: e }) => e.colors.neutral[90]};
    border-radius: ${({ theme: e }) => e.borders.radius.xs};
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: ${({ theme: e }) => e.borders.radius.xs};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme: e }) => e.colors.neutral[80]};
    border-radius: ${({ theme: e }) => e.borders.radius.xs};
  }
  /* Scrollbar for Firefox */
  @supports (scrollbar-width: thin) {
    * {
      scrollbar-width: thin;
      scrollbar-color: ${({ theme: e }) => `${e.colors.neutral[80]} ${e.colors.neutral[90]}`};
    }
  }
`, er = "48px", Ya = (e, t) => `linear-gradient(
    to bottom,
    ${e ? "transparent" : "black"} 0%,
    black ${e ? er : "0px"},
    black calc(100% - ${t ? er : "0px"}),
    ${t ? "transparent" : "black"} 100%
  )`, Ga = L.div`
  overflow: auto;
  width: 100%;
  border-radius: ${({ theme: e }) => e.borders.radius.l};
  max-height: inherit;

  /* Hide scrollbar for Chrome, Safari, and Edge */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for Firefox */
  scrollbar-width: none;

  /* Additional styles for cross-browser compatibility */
  -ms-overflow-style: none; /* IE and Edge */

  &:hover ~ ${Kr} {
    opacity: 1;
  }

  ${({ isContentScrollable: e, showTopFade: t, showBottomFade: r }) => {
  if (!e) return "";
  const n = Ya(t, r);
  return Un`
      /* Keep -webkit- for Safari */
      -webkit-mask-image: ${n};
      mask-image: ${n};
      mask-size: 100% 100%;
      mask-repeat: no-repeat;
    `;
}}
`, Xa = L.div`
  height: ${({ height: e }) => e};
`, za = L.div`
  @media only screen and (max-width: 767px) {
    padding: ${({ theme: e }) => `${e.spacings.xs2} ${e.spacings.xs}`};
  }

  @media only screen and (min-width: 768px) {
    padding: ${({ theme: e }) => `${e.spacings.xs} ${e.spacings.m}`};
  }
`, Ka = L.div`
  margin: ${({ theme: e }) => `${e.spacings.xs3} 0 ${e.spacings.xs4} 0`};
`, qr = L.div`
  position: absolute;
  left: 0;
  width: 100%;
  height: 1px;
  opacity: 0;
  pointer-events: none;
`, qa = L(qr)`
  top: 0;
`, Ja = L(qr)`
  bottom: 0;
`, Za = L.div`
  position: relative;
`, tr = 16, Qa = ({
  children: e,
  hideClose: t,
  onUpdateDimensions: r
}) => {
  let n, a, i, u, c = [];
  U.Children.forEach(e, (P) => {
    if (U.isValidElement(P))
      switch (P.type) {
        case Xr:
          a = P;
          break;
        case Gr:
          n = P;
          break;
        case zr:
          i = P;
          break;
        case Yr:
          u = P;
          break;
        default:
          c.push(P);
          break;
      }
  });
  const f = ee(null), d = ee(null), p = ee(null), h = ee(null), y = ee(null), E = ee(null), T = ee(null), [l, g] = Z(!1), [C, w] = Z(be.InsideTopRight), [x, O] = Z(), [R, j] = Z(), [D, F] = Z(!1), [V, Q] = Z(!1), Ye = x ? x - tr : 0, Re = R ? R - tr : 0, X = () => {
    const P = document.createElement("div");
    document.body.appendChild(P), P.style.width = "calc(100vw - 120px)";
    const A = window.getComputedStyle(P).width;
    return document.body.removeChild(P), A;
  }, H = An(() => {
    var he;
    const P = h.current, A = p.current;
    if (!P || !A) return;
    const K = A.offsetHeight;
    j(K);
    const Y = P.offsetHeight;
    O(Y);
    const re = A.offsetHeight > P.clientHeight, xe = ((he = y.current) == null ? void 0 : he.offsetWidth) ?? 0;
    g(re), r == null || r(
      re,
      P.clientWidth,
      xe
    );
    const ve = X();
    if (!(!P.clientWidth || !ve))
      if (re) {
        const Te = P.clientWidth <= parseInt(ve, 10);
        w(Te ? be.OutsideRightTop : be.OutsideTopRight);
      } else
        w(be.InsideTopRight);
  }, [r]);
  return et(() => {
    const P = h.current;
    if (!P) return;
    const A = new IntersectionObserver(
      (K) => {
        for (const Y of K)
          Y.target === E.current && F(!Y.isIntersecting), Y.target === T.current && Q(!Y.isIntersecting);
      },
      { root: P, threshold: 0 }
    );
    return E.current && A.observe(E.current), T.current && A.observe(T.current), () => A.disconnect();
  }, [e]), et(() => {
    const P = h.current, A = f.current;
    if (!P || !A) return;
    const K = () => {
      A && (A.scrollTop = P.scrollTop);
    }, Y = () => {
      P && (P.scrollTop = A.scrollTop);
    };
    return P.addEventListener("scroll", K), A.addEventListener("scroll", Y), () => {
      P.removeEventListener("scroll", K), A.removeEventListener("scroll", Y);
    };
  }, []), et(() => {
    H(), window.addEventListener("resize", H);
    const P = p.current;
    if (!P) return;
    const A = new window.ResizeObserver(() => {
      H();
    });
    return A.observe(P), () => {
      A.disconnect(), window.removeEventListener("resize", H);
    };
  }, [H]), /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    !t && /* @__PURE__ */ m.jsx(Ma, { asChild: !0, children: /* @__PURE__ */ m.jsx(
      Ua,
      {
        position: C,
        "aria-label": "Fechar",
        ref: y,
        children: /* @__PURE__ */ m.jsx(
          Ln,
          {
            variant: "default",
            type: "primary",
            size: "small",
            icon: "IconX"
          }
        )
      }
    ) }),
    /* @__PURE__ */ m.jsx(
      Ga,
      {
        isContentScrollable: l,
        ref: h,
        showTopFade: D,
        showBottomFade: V,
        children: /* @__PURE__ */ m.jsxs(Za, { ref: p, children: [
          /* @__PURE__ */ m.jsx(qa, { ref: E }),
          n,
          /* @__PURE__ */ m.jsxs(za, { children: [
            a && /* @__PURE__ */ m.jsx(Ha, { children: a }),
            i && /* @__PURE__ */ m.jsx(Ka, { children: i }),
            u && /* @__PURE__ */ m.jsx(Va, { children: u }),
            c
          ] }),
          /* @__PURE__ */ m.jsx(Ja, { ref: T })
        ] })
      }
    ),
    /* @__PURE__ */ m.jsx(
      Kr,
      {
        ref: f,
        height: `${Ye}px`,
        children: /* @__PURE__ */ m.jsx(
          Xa,
          {
            ref: d,
            height: `${Re}px`
          }
        )
      }
    )
  ] });
}, Jr = L(Fn)`
  min-width: 160px;
  overflow: hidden;

  @media only screen and (max-width: 575px) {
    width: 100%;
  }
`, ei = L.div`
  background-color: white;
  border-top: ${({ theme: e }) => `${e.borders.width.xs2} solid ${e.colors.neutral[90]}`};

  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ justifyContent: e }) => e};
  gap: ${({ gap: e }) => e};

  border-bottom-left-radius: ${({ theme: e }) => e.borders.radius.l};
  border-bottom-right-radius: ${({ theme: e }) => e.borders.radius.l};

  @media only screen and (max-width: 575px) {
    flex-direction: column-reverse;
    flex-wrap: wrap;
  }

  @media only screen and (max-width: 767px) {
    padding: ${({ theme: e }) => `${e.spacings.xs3} ${e.spacings.xs}`};
  }

  @media only screen and (min-width: 767px) {
    padding: ${({ theme: e }) => `${e.spacings.xs3} ${e.spacings.m}`};
  }
`, ti = L.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${({ theme: e }) => e.spacings.xs3};

  ${({ centered: e }) => e && `
    justify-content: center;
    gap: 0;
  `}

  @media only screen and (max-width: 575px) {
    width: 100%;
    flex-direction: column-reverse;
  }
`, Zr = ({ children: e, ...t }) => /* @__PURE__ */ m.jsx(Wn, { ...t, variant: "neutral", children: e }), Qr = ({
  children: e,
  fullWidth: t = !1,
  size: r = "medium",
  ...n
}) => /* @__PURE__ */ m.jsx(
  Jr,
  {
    ...n,
    minWidth: t ? "100%" : void 0,
    size: r,
    variant: "primary",
    children: e
  }
), en = ({
  children: e,
  size: t = "medium",
  fullWidth: r = !1,
  ...n
}) => /* @__PURE__ */ m.jsx(
  Jr,
  {
    ...n,
    minWidth: r ? "100%" : void 0,
    size: t,
    variant: "secondary",
    children: e
  }
), ri = ar(
  ({ children: e, ...t }, r) => {
    let n, a, i;
    const u = [], f = U.Children.toArray(e).filter(
      (h) => U.isValidElement(h) && h.type !== U.Fragment
    ).length === 1;
    U.Children.forEach(e, (h) => {
      if (U.isValidElement(h))
        switch (h.type) {
          case Zr:
            n = U.cloneElement(
              h,
              {
                ...h.props
              }
            );
            break;
          case Qr:
            a = U.cloneElement(
              h,
              {
                ...h.props,
                fullWidth: f
              }
            );
            break;
          case en:
            i = U.cloneElement(
              h,
              {
                ...h.props,
                fullWidth: f
              }
            );
            break;
          default:
            u.push(h);
            break;
        }
    });
    const d = f ? "center" : n ? "space-between" : "flex-end", p = f || !n ? "0" : "12px";
    return /* @__PURE__ */ m.jsxs(
      ei,
      {
        ...t,
        ref: r,
        justifyContent: d,
        gap: p,
        children: [
          u,
          n,
          (a || i) && /* @__PURE__ */ m.jsxs(ti, { centered: f, children: [
            i,
            a
          ] })
        ]
      }
    );
  }
), Se = ri;
Se.CancelButton = Zr;
Se.PrimaryButton = Qr;
Se.SecondaryButton = en;
var tn = yr(), lt = function() {
}, He = s.forwardRef(function(e, t) {
  var r = s.useRef(null), n = s.useState({
    onScrollCapture: lt,
    onWheelCapture: lt,
    onTouchMoveCapture: lt
  }), a = n[0], i = n[1], u = e.forwardProps, c = e.children, f = e.className, d = e.removeScrollBar, p = e.enabled, h = e.shards, y = e.sideCar, E = e.noIsolation, T = e.inert, l = e.allowPinchZoom, g = e.as, C = g === void 0 ? "div" : g, w = e.gapMode, x = gt(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), O = y, R = br([r, t]), j = W(W({}, x), a);
  return s.createElement(
    s.Fragment,
    null,
    p && s.createElement(O, { sideCar: tn, removeScrollBar: d, shards: h, noIsolation: E, inert: T, setCallbacks: i, allowPinchZoom: !!l, lockRef: r, gapMode: w }),
    u ? s.cloneElement(s.Children.only(c), W(W({}, j), { ref: R })) : s.createElement(C, W({}, j, { className: f, ref: R }), c)
  );
});
He.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
He.classNames = {
  fullWidth: Ce,
  zeroRight: Ee
};
var pt = !1;
if (typeof window < "u")
  try {
    var Me = Object.defineProperty({}, "passive", {
      get: function() {
        return pt = !0, !0;
      }
    });
    window.addEventListener("test", Me, Me), window.removeEventListener("test", Me, Me);
  } catch {
    pt = !1;
  }
var ue = pt ? { passive: !1 } : !1, ni = function(e) {
  return e.tagName === "TEXTAREA";
}, rn = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !ni(e) && r[t] === "visible")
  );
}, oi = function(e) {
  return rn(e, "overflowY");
}, ai = function(e) {
  return rn(e, "overflowX");
}, rr = function(e, t) {
  var r = t.ownerDocument, n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var a = nn(e, n);
    if (a) {
      var i = on(e, n), u = i[1], c = i[2];
      if (u > c)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, ii = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, si = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, nn = function(e, t) {
  return e === "v" ? oi(t) : ai(t);
}, on = function(e, t) {
  return e === "v" ? ii(t) : si(t);
}, ci = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, ui = function(e, t, r, n, a) {
  var i = ci(e, window.getComputedStyle(t).direction), u = i * n, c = r.target, f = t.contains(c), d = !1, p = u > 0, h = 0, y = 0;
  do {
    var E = on(e, c), T = E[0], l = E[1], g = E[2], C = l - g - i * T;
    (T || C) && nn(e, c) && (h += C, y += T), c instanceof ShadowRoot ? c = c.host : c = c.parentNode;
  } while (
    // portaled content
    !f && c !== document.body || // self content
    f && (t.contains(c) || t === c)
  );
  return (p && (Math.abs(h) < 1 || !a) || !p && (Math.abs(y) < 1 || !a)) && (d = !0), d;
}, Le = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, nr = function(e) {
  return [e.deltaX, e.deltaY];
}, or = function(e) {
  return e && "current" in e ? e.current : e;
}, li = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, fi = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, di = 0, le = [];
function vi(e) {
  var t = s.useRef([]), r = s.useRef([0, 0]), n = s.useRef(), a = s.useState(di++)[0], i = s.useState(bt)[0], u = s.useRef(e);
  s.useEffect(function() {
    u.current = e;
  }, [e]), s.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var l = gr([e.lockRef.current], (e.shards || []).map(or), !0).filter(Boolean);
      return l.forEach(function(g) {
        return g.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), l.forEach(function(g) {
          return g.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var c = s.useCallback(function(l, g) {
    if ("touches" in l && l.touches.length === 2 || l.type === "wheel" && l.ctrlKey)
      return !u.current.allowPinchZoom;
    var C = Le(l), w = r.current, x = "deltaX" in l ? l.deltaX : w[0] - C[0], O = "deltaY" in l ? l.deltaY : w[1] - C[1], R, j = l.target, D = Math.abs(x) > Math.abs(O) ? "h" : "v";
    if ("touches" in l && D === "h" && j.type === "range")
      return !1;
    var F = rr(D, j);
    if (!F)
      return !0;
    if (F ? R = D : (R = D === "v" ? "h" : "v", F = rr(D, j)), !F)
      return !1;
    if (!n.current && "changedTouches" in l && (x || O) && (n.current = R), !R)
      return !0;
    var V = n.current || R;
    return ui(V, g, l, V === "h" ? x : O, !0);
  }, []), f = s.useCallback(function(l) {
    var g = l;
    if (!(!le.length || le[le.length - 1] !== i)) {
      var C = "deltaY" in g ? nr(g) : Le(g), w = t.current.filter(function(R) {
        return R.name === g.type && (R.target === g.target || g.target === R.shadowParent) && li(R.delta, C);
      })[0];
      if (w && w.should) {
        g.cancelable && g.preventDefault();
        return;
      }
      if (!w) {
        var x = (u.current.shards || []).map(or).filter(Boolean).filter(function(R) {
          return R.contains(g.target);
        }), O = x.length > 0 ? c(g, x[0]) : !u.current.noIsolation;
        O && g.cancelable && g.preventDefault();
      }
    }
  }, []), d = s.useCallback(function(l, g, C, w) {
    var x = { name: l, delta: g, target: C, should: w, shadowParent: hi(C) };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(O) {
        return O !== x;
      });
    }, 1);
  }, []), p = s.useCallback(function(l) {
    r.current = Le(l), n.current = void 0;
  }, []), h = s.useCallback(function(l) {
    d(l.type, nr(l), l.target, c(l, e.lockRef.current));
  }, []), y = s.useCallback(function(l) {
    d(l.type, Le(l), l.target, c(l, e.lockRef.current));
  }, []);
  s.useEffect(function() {
    return le.push(i), e.setCallbacks({
      onScrollCapture: h,
      onWheelCapture: h,
      onTouchMoveCapture: y
    }), document.addEventListener("wheel", f, ue), document.addEventListener("touchmove", f, ue), document.addEventListener("touchstart", p, ue), function() {
      le = le.filter(function(l) {
        return l !== i;
      }), document.removeEventListener("wheel", f, ue), document.removeEventListener("touchmove", f, ue), document.removeEventListener("touchstart", p, ue);
    };
  }, []);
  var E = e.removeScrollBar, T = e.inert;
  return s.createElement(
    s.Fragment,
    null,
    T ? s.createElement(i, { styles: fi(a) }) : null,
    E ? s.createElement(Sr, { gapMode: e.gapMode }) : null
  );
}
function hi(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const pi = Cr(tn, vi);
var an = s.forwardRef(function(e, t) {
  return s.createElement(He, W({}, e, { ref: t, sideCar: pi }));
});
an.classNames = He.classNames;
const mi = L.div`
  background-color: #3b2e3748;
  z-index: ${Ve.Overlay};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`, gi = () => /* @__PURE__ */ m.jsx(an, { noIsolation: !0, children: /* @__PURE__ */ m.jsx(mi, {}) }), bi = "480px", yi = "800px", Ei = "960px", Ci = L.div`
  border-radius: ${({ theme: e }) => e.borders.radius.l};
  background-color: ${({ theme: e }) => e.colors.neutral[100]};
  box-shadow: 0px 8px 32px 0px #00000029;
  max-height: calc(100vh - 64px);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: ${Ve.Content};

  ${({ maxHeight: e }) => e && `max-height: ${e}`};

  ${({ size: e }) => ({
  small: `
        width: ${bi};
        @media only screen and (max-width: 575px) {
    width: calc(100% - 48px);
}
    `,
  medium: `
         width: ${yi};
        @media only screen and (max-width: 864px) {
    width: calc(100% - 48px);
}
    `,
  large: `
     width: ${Ei};
        @media only screen and (max-width: 1024px) {
    width: calc(100% - 48px);
}
    `
})[e]}
`;
function wi(e) {
  return e == null;
}
const Si = ar(
  ({ children: e, disableCloseOnOverlayClick: t, hideClose: r, ...n }, a) => {
    let i, u = [];
    U.Children.forEach(e, (E) => {
      if (U.isValidElement(E))
        switch (E.type) {
          case Se:
            i = E;
            break;
          default:
            u.push(E);
            break;
        }
    });
    const { size: c } = Fa(), [f, d] = Z(), p = (E, T, l) => {
      const g = l ? l + 32 : 0;
      E && T > window.innerWidth - g - 48 ? d(window.innerHeight - g - 64) : d(void 0);
    }, h = document.getElementById("flamingo-ui-modal"), y = (E) => E.preventDefault();
    return /* @__PURE__ */ m.jsxs($a, { container: h, children: [
      /* @__PURE__ */ m.jsx(gi, {}),
      /* @__PURE__ */ m.jsx(
        Aa,
        {
          asChild: !0,
          onInteractOutside: (E) => t && E.preventDefault(),
          onCloseAutoFocus: y,
          ref: a,
          children: /* @__PURE__ */ m.jsxs(
            Ci,
            {
              ...n,
              size: c,
              maxHeight: wi(f) ? void 0 : `${f}px`,
              children: [
                /* @__PURE__ */ m.jsx(
                  Qa,
                  {
                    hideClose: r,
                    maxHeight: f,
                    onUpdateDimensions: p,
                    children: u
                  }
                ),
                i
              ]
            }
          )
        }
      )
    ] });
  }
), Ri = {
  Root: Si,
  Hero: Gr,
  Highlight: Xr,
  Title: zr,
  Description: Yr,
  Footer: Se
}, xi = U.forwardRef(({ children: e, ...t }, r) => /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
  e && /* @__PURE__ */ m.jsx(Qt, { asChild: !0, ...t, ref: r, children: e }),
  !e && /* @__PURE__ */ m.jsx(Qt, {})
] })), Ni = {
  Root: La,
  Trigger: xi,
  Content: Ri
};
export {
  Ni as Modal
};
//# sourceMappingURL=flamingo-ui-modal.es.js.map
